import React from "react"
import { withStyles } from "@material-ui/core/styles"
import Helmet from "react-helmet"

import { Text, Headline } from "ui-Text"
import Button from "@material-ui/core/Button"
import StaticDialog, {
  StaticDialogBody,
  StaticDialogContainer,
  StaticDialogContent,
  StaticDialogFooter,
  StaticDialogFootnote,
  StaticDialogHeader,
} from "ui-StaticDialog"

const styleSheet = theme => ({
  logo: {
    height: theme.spacing.unit * 10,
  },
})

function Missing({ classes }) {
  return (
    <StaticDialogContainer>
      <StaticDialog>
        <StaticDialogHeader>
          <a href="/">
            <img
              src={require("../../../../static/images/logo.svg")}
              alt="JA Lactation Support"
              className={classes.logo}
            />
          </a>
        </StaticDialogHeader>
        <StaticDialogBody>
          <StaticDialogContent>
            <Helmet>
              <title>Oops, can't find that page - 404 Not Found</title>
            </Helmet>
            <Headline paragraph>Oops, can't find that page</Headline>
            <Text>Sorry about that! Perhaps one of these links will help you get started?</Text>
            <Text component="div">
              <ul>
                <li>
                  <a href="/breastfeeding-support/in-home-consultation">
                    In Home Postpartum Consultation
                  </a>
                </li>
                <li>
                  <a href="/breastfeeding-support">Breastfeeding Support Services</a>
                </li>
                <li>
                  <a href="/">Home Page</a>
                </li>
              </ul>
            </Text>
            <Text />
          </StaticDialogContent>
        </StaticDialogBody>
        <StaticDialogFootnote>404 Not Found</StaticDialogFootnote>
      </StaticDialog>
    </StaticDialogContainer>
  )
}

export default withStyles(styleSheet)(Missing)



// WEBPACK FOOTER //
// ./src/views/pages/Errors/Missing.js